import { Footer } from "../components/Footer"
import { PriorityMethods } from "../components/deposit/PriorityMethods"
import { CoinFlowMethods } from "../components/deposit/CoinFlowMethods"


export const DepositCoinflowPage = () => {
    return (
        <div className="container">
            <PriorityMethods />
            <CoinFlowMethods />
            <Footer />
        </div>
    );
}